import React from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {Flex} from '@vio/atlas/helpers/Flex'
import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import useGenerateAppDownloadUrl from 'hooks/useGenerateAppDownloadUrl'
import {getCurrencyCode} from 'modules/meta/selectors'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'

import {Placement} from '@daedalus/core/src/deepLinking/types'

import {QrCode} from '../QrCode/QrCode'

const Wrapper = styled(Flex.Column)`
  padding: 0 ${cssTheme.layout.spacing.s600};
`

const QrCodeWrapper = styled(NoStyleLink)`
  margin: auto;
  background-color: ${cssTheme.colors.background.neutral.c000};
  padding: ${cssTheme.layout.spacing.s600} 0;
  border: 1px solid ${cssTheme.colors.background.neutral.c000};
  border-radius: ${cssTheme.layout.radius.lg};
  z-index: 2;
  padding: ${cssTheme.layout.spacing.s600};
  width: 193px;
  height: 193px;
`

interface Props {
  hotelId?: string
  offer?: SearchOffer
  placement: Placement
}
export const DownloadAppQrCode: React.FC<Props> = ({
  hotelId = '',
  offer = undefined,
  placement
}) => {
  const {formatMessage} = useIntl()
  const downloadAppMessage = formatMessage({
    id: 'web2appPopup.scanQrToGetApp',
    defaultMessage: 'Scan this QR code to get the app'
  })

  const searchParams = useSelector(getSearchParameters)
  const {generateAppLockedDealDeepLink, generateGeneralDeepLink} =
    useGenerateAppDownloadUrl()
  const currencyCode = useSelector(getCurrencyCode)

  const appDownloadUrl = offer
    ? generateAppLockedDealDeepLink(placement, {
        // This hotelId has to be passed here because we need to both placeId and hotelId passed to deeplink because sometimes due to the user search it has no hotelId in the searchParameters
        hotelId: hotelId ?? searchParams.hotelId,
        optimizeAnchorRooms: searchParams.optimizeAnchorRooms ? 1 : 0,
        optimizeRooms: searchParams.optimizeRooms ? 1 : 0,
        clickedOfferRate: offer?.totalRate,
        currencyCode
      })
    : generateGeneralDeepLink(placement, {
        optimizeAnchorRooms: searchParams.optimizeAnchorRooms ? 1 : 0,
        optimizeRooms: searchParams.optimizeRooms ? 1 : 0
      })

  return (
    <Wrapper gap="s400">
      <QrCodeWrapper target="_blank" href={appDownloadUrl}>
        <QrCode size={145} />
      </QrCodeWrapper>
      <Text variant="bodyS" colorPath="content.neutral.c000" align="center">
        {downloadAppMessage}
      </Text>
    </Wrapper>
  )
}
